import { createSlice } from '@reduxjs/toolkit';

const iconList = [
  {
    title: 'Trii Team',
    icon: '/img/triiModules/TriiTeam.svg',
    module: '/a/team',
  },
  {
    title: 'Trii Chat',
    icon: '/img/triiModules/TriiChat.svg',
    module: '/a/chat',
  },
  {
    title: 'Trii Marketing',
    icon: '/img/triiModules/TriiMarketing.svg',
    module: '/a/marketing',
  },
  {
    title: 'Trii Ticket',
    icon: '/img/triiModules/TriiTickets.svg',
    module: '/a/tickets',
  },
  {
    title: 'Trii Service',
    icon: '/img/triiModules/TriiService.svg',
    module: '/a/service',
  },
  {
    title: 'Trii Cobranzas',
    icon: '/img/triiModules/TriiCobranzas.svg',
    module: '/a/collection',
  },
  {
    title: 'Trii Contactos',
    icon: '/img/triiModules/TriiContacts.svg',
    module: '/a/contacts',
  },
  {
    title: 'Trii Llamadas',
    icon: '/img/triiModules/TriiCall.svg',
    module: '/a/calls',
  },
];

const initialState = {
  iconList,
};


export const iconNavSlice = createSlice({
  name: 'iconNav',
  initialState,
  //   reducers: {
  //     increment: (state) => {
  //       state.value += 1;
  //     },
  //   },
});

export const selectIcon = state => state.iconNav.iconList;

// Action creators are generated for each case reducer function
// export const { increment } = iconNavSlice.actions;

export default iconNavSlice.reducer;
